export default __webpack_public_path__ + "7592ed9f3e6cebaa39c50fbf35dd8678.png";